<template>
  <!-- 机器人答案满意度评价 -->
  <div class="answer-satisfy" v-if="showComment">
    <div class="flex">
      <div
        :class="answerFrom.score === 1 ? 'comment-active' : ''"
        class="answer-satisfy__comment flex flex-column flex-center flex-item-center"
        @click="answerFrom.score = 1"
      >
        <i class="iconfont icon-haoping"></i>
        <span>好评</span>
      </div>
      <div
        :class="answerFrom.score === 0 ? 'comment-active' : ''"
        class="answer-satisfy__comment flex flex-column flex-center flex-item-center"
        @click="answerFrom.score = 0"
      >
        <i class="iconfont icon-chaping"></i>
        <span>差评</span>
      </div>
    </div>
    <div style="margin-top: 12px" v-if="config.commentReason && answerFrom.score === 0">
      <div class="flex flex-wrap">
        <div
          :class="['answer-satisfy__tag', answerFrom.tag.includes(item1) ? 'tag-active' : '']"
          v-for="(item1, index1) in config.navCommentTag"
          :key="index1"
          @click="handleSelectTag(item1)"
        >
          {{ item1 }}
        </div>
      </div>
      <el-input
        type="textarea"
        :maxlength="200"
        :minlength="5"
        show-word-limit
        :autosize="{ minRows: 2 }"
        v-model="answerFrom.reason"
        :placeholder="config.commentPlaceholder"
      />
      <div class="flex">
        问题是否解决：
        <el-switch v-model="answerFrom.solveType" :inactive-value="0" :active-value="1" />
      </div>
    </div>
    <div class="answer-satisfy__btn flex flex-center" @click="handleAnswerComment(item)">提交</div>
  </div>
</template>
<script setup>
import { defineProps, computed, ref, getCurrentInstance, defineEmits } from 'vue'
import { ElMessage } from 'element-plus'
const { proxy } = getCurrentInstance()
const props = defineProps({
  styleConfig: { type: Object, default: () => {} },
  item: { type: Object, default: () => {} },
  showType: { type: Number, default: 1 },
  msgList: { type: Array, default: () => [] },
  index: { type: Number, default: 0 },
  orgId: { type: String },
  chatId: { type: String },
})
const emit = defineEmits(['switch'])
const config = computed(() => {
  if (props.styleConfig && Object.keys(props.styleConfig).length > 0) {
    return props.styleConfig
  } else {
    return {
      robotComment: false,
      negativeComment: false,
      negativeCommentForm: {},
    }
  }
})
const showComment = computed(() => {
  if (
    config.value.robotComment &&
    props.showType === 1 &&
    props.item.value === 2 &&
    props.item.type === 1 &&
    props.item.knowledge
  ) {
    return true
  }
  return false
})
// 机器人答案评价
const answerFrom = ref({
  solveType: 1,
  reason: '',
  tag: [],
  score: 1
})
// 机器人答案评价选标签
const handleSelectTag = (item) => {
  let index = answerFrom.value.tag.indexOf(item)
  if (index === -1) {
    answerFrom.value.tag.push(item)
  } else {
    answerFrom.value.tag.splice(index, 1)
  }
}
// 提交机器人答案评价
const handleAnswerComment = async (item) => {
  if (answerFrom.value.score === 0 && config.value.commentReason && (!answerFrom.value.reason || answerFrom.value.reason === '')) {
    return ElMessage.error('评论内容不能为空！')
  }
  let q = ''
  for (let i = props.index; i > 0; i--) {
    if (props.msgList[i].value === 3 && props.msgList[i].type === 1 && q != '') {
      q = props.msgList[i].text
    }
  }
  let data = {
    content: answerFrom.value.reason,
    orgId: props.orgId,
    question: q,
    subject: props.msgList[props.index].text,
    tags: answerFrom.value.tag,
    userId: localStorage.getItem('senderId') || '',
    knowledgeId: item.knowledge.id,
    knowledgeType: item.knowledge.type,
    solveType: answerFrom.value.solveType,
    score: answerFrom.value.score,
    sessionId: props.chatId
  }
  data.content = answerFrom.value.score === 1 ? '好评' : answerFrom.value.reason
  let res = await proxy.$http.post('/textrobot/app/answer/comment', data)
  if (res.code === 0) {
    ElMessage.success('感谢您的反馈！')
    // if (answerFrom.value.score === 0 && config.value.negativeComment) {
    //   emit('switch', { type: 7, groupId: config.value.negativeCommentForm.servicesId })
    // }
    if (res.data != null) {
      emit('comentResult', res.data)
    }
    answerFrom.value = { solveType: 1, reason: '', tag: [], score: 1 }
  } else {
    ElMessage.error(res.msg)
  }
}
</script>
<style lang="less" scoped>
.answer-satisfy {
  border-top: 1px solid #ececec;
  margin-top: 15px;
  padding-top: 15px;
  &__comment {
    width: 50%;
    font-weight: 500;
    font-size: 13px;
    color: #444444;
    cursor: pointer;
    .iconfont {
      color: #e9e9e9;
      font-size: 20px;
      margin-bottom: 4px;
    }
  }
  .comment-active {
    color: #3571f0;
    .iconfont {
      color: #3571f0;
    }
  }
  &__tag {
    font-weight: 500;
    font-size: 12px;
    color: #555555;
    padding: 4px 12px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    margin: 0 12px 12px 0;
    cursor: pointer;
  }
  .tag-active {
    color: #3571f0;
    border-color: #3571f0;
  }
  &__btn {
    font-size: 14px;
    color: #ffffff;
    margin-top: 12px;
    background-color: #3571f0;
    padding: 8px;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
